import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useRequireAuth } from '../hooks/useAuth';
import { Spinner } from './Spinner';

export function LayoutShell() {
  const status = useRequireAuth();

  if (status === 'unknown') {
    return (
      <div className="flex min-h-screen items-center justify-center text-zinc-500">
        <Spinner size={24} />
      </div>
    );
  }

  if (status === 'anonymous') {
    return null;
  }

  return (
    <div className="flex min-h-screen bg-zinc-950">
      <Sidebar />
      <div className="flex flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
